import { Link } from '../app/navigation';
import { Brand } from './Brand';

export function PublicHeader() {
  return (
    <header className="public-header">
      <Brand compact />
      <nav aria-label="공개 메뉴">
        <Link href="/diagnosis">도입 진단</Link>
        <Link href="/pricing">이용 기준</Link>
        <Link href="/support">도움</Link>
        <Link href="/sign-in" className="text-action">로그인</Link>
        <Link href="/start" className="public-start-link">학원 시작</Link>
      </nav>
    </header>
  );
}
